import { Asterisk } from "lucide-react";

const ITEMS = ["Nutrition", "Movement", "Hydration", "Progress", "Playful accountability", "Built in Wisconsin"];

function Row({ ariaHidden = false }) {
  return (
    <div className="flex shrink-0 items-center" aria-hidden={ariaHidden}>
      {ITEMS.map((item) => (
        <span key={item} className="flex items-center">
          <span className="whitespace-nowrap px-6 font-display text-2xl font-medium text-nom-ink sm:px-10 sm:text-3xl">
            {item}
          </span>
          <Asterisk className="h-6 w-6 shrink-0 text-nom-coral sm:h-8 sm:w-8" aria-hidden="true" />
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <div className="overflow-hidden border-y border-nom-border bg-nom-peach/45 py-5 sm:py-6" data-testid="marquee-ribbon">
      <div className="marquee-track">
        <Row />
        <Row ariaHidden />
      </div>
    </div>
  );
}
